module.exports = __webpack_public_path__ + "officialStatic/img/new20.d26c60f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new20.jpg
// module id = JfhD
// module chunks = 0